/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cdo_Toast_Cancel_ErrInputs */

const vi_cdo_toast_cancel_err = /** @type {(inputs: Cdo_Toast_Cancel_ErrInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Huỷ đơn thất bại`)
};

/**

* @param {Cdo_Toast_Cancel_ErrInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const cdo_toast_cancel_err = /** @type {((inputs?: Cdo_Toast_Cancel_ErrInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cdo_Toast_Cancel_ErrInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_cdo_toast_cancel_err(inputs)
});